import React from "react";
import Carousel from 'react-bootstrap/Carousel'

class ControlledCarousel extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.handleSelect = this.handleSelect.bind(this);

    this.state = {
      index: 0,
      direction: null,
    };
  }

  handleSelect(selectedIndex, e) {
    this.setState({
      index: selectedIndex,
      direction: e.direction,
    });
  }

  render() {
    const { index, direction } = this.state;

    return (
      <Carousel
        activeIndex={index}
        direction={direction}
        onSelect={this.handleSelect}
      >
        <Carousel.Item>
          <img
            className="d-block w-100"
            src="https://www.wallpaperflare.com/static/77/154/473/server-room-lights-dark-wallpaper.jpg"
            alt="First slide"
          />
          <Carousel.Caption>
            <h3>Los Angeles</h3>
            <p>Nulla vitae elit libero, a pharetra augue mollis interdum.</p>
          </Carousel.Caption>
        </Carousel.Item>
        <Carousel.Item>
          <img
            className="d-block w-100"
            src="https://d2v9y0dukr6mq2.cloudfront.net/video/thumbnail/Vfv9BDZagiltwcyiq/videoblocks-big-empty-warehouse_rkwfj2y5tl_thumbnail-full01.png"
            alt="Second slide"
          />

          <Carousel.Caption>
            <h3>New York</h3>
            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
          </Carousel.Caption>
        </Carousel.Item>
        <Carousel.Item>
          <img
            className="d-block w-100"
            src="        https://www.commercialpropertyguide.com.au/images/blog-cropped/static/images/blog/cpg-warehouse-003.jpg
"
            alt="Third slide"
          />

          <Carousel.Caption>
            <h3>Chicago</h3>
            <p>
              Praesent commodo cursus magna, vel scelerisque nisl consectetur.
            </p>
          </Carousel.Caption>
        </Carousel.Item>
      </Carousel>
    );
  }
}

export default ControlledCarousel
